export var PHONE_AUTH_CHANGE_PHONE_TYPE = 'phoneAuth/changePhone';
export var PHONE_AUTH_SEND_CODE_TYPE = 'phoneAuth/sendCode/status_changed';
export var PHONE_AUTH_SEND_VALIDATION_CODE_TYPE = 'phoneAuth/sendValidationCode/status_changed';
export var PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE = 'phoneAuth/registerOrAuthorize/status_changed';
export var PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE = 'phoneAuth/registerOrAuthorizeByToken/status_changed';
export var PHONE_AUTH_AUTHENTICATE_BY_TOKEN = 'phoneAuth/authenticateByToken/status_changed';